import { Popover } from 'antd';
import { ABHAIcon } from '../components/common/Icons';

const RegisterInABHAAndEarn: React.FC<{
    onRegister: () => void;
}> = ({ onRegister }) => {
    return (
        <Popover
            placement="bottom"
            trigger="hover"
            overlayInnerStyle={{
                borderRadius: '16px',
            }}
            className="cursor-pointer"
            content={
                <div className="flex flex-col space-y-16 p-8 max-w-204 rounded-8">
                    <div className="flex space-x-8 items-center p-8 rounded-8 bg-darwin-accent-light-yellow">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="16"
                            width="20"
                            viewBox="0 0 640 512"
                            fill="currentColor"
                            className="fill-darwin-accent-bright-yellow-800 w-16 h-16"
                        >
                            <path d="M272.5 5.7c9-7.6 22.1-7.6 31.1 0L526.1 194.6c-9.8-1.7-19.9-2.6-30.1-2.6c-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8V432c0 17.7 14.3 32 32 32H348.5c12.3 18.8 28 35.1 46.3 48H144c-44.2 0-80-35.8-80-80V245.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256h40.2c-15.3 18.5-26.9 40.2-33.6 64H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"></path>
                        </svg>
                        <p className="text-darwin-accent-dark-yellow">HFR Creation Pending!</p>
                    </div>
                    <div className="flex items-center space-x-8">
                        {<ABHAIcon isActive={false} leafColor="#19A66A" dotColor="#D74B41" />}
                        <div className="flex flex-col items-start">
                            <p
                                className="text-16 font-900"
                                style={{
                                    lineHeight: '1.25rem',
                                }}
                            >
                                Earn with Eka:
                            </p>
                            <p
                                className="text-13 font-700"
                                style={{
                                    lineHeight: '1rem',
                                }}
                            >
                                An <span className="text-darwin-green-primary">ABDM</span>{' '}
                                Initiative
                            </p>
                        </div>
                    </div>
                    <p className="text-12 font-700 text-darwin-neutral_new-800">
                        Enrol into DHIS and start receiving incentive of ₹20 per record linked
                    </p>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onRegister();
                        }}
                        className="h-36 px-16 btn-small rounded-8 bg-darwin-accent-bright-blue-800 text-white text-14 font-700 flex items-center justify-center space-x-8"
                    >
                        <span className="text-center text-13">Register Now</span>
                        <svg
                            className="w-16 h-16 fill-white"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                        >
                            <path d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"></path>
                        </svg>
                    </button>
                </div>
            }
            destroyTooltipOnHide={true}
            overlayClassName="popover-p-0"
            zIndex={1050}
        >
            <div className="px-3">
                {<ABHAIcon leafColor="#A3A8C2" dotColor="#484848" size={'18'} />}
            </div>
        </Popover>
    );
};

export default RegisterInABHAAndEarn;
